module.exports = __webpack_public_path__ + "static/img/game.a6bac47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/game.png
// module id = tgya
// module chunks = 1